import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useT } from '~app/core/BundleProvider';
import { actions as CanvasActions } from '~app/features/canvas';
import { actions as SaveLoadActions } from '~app/features/saveLoad';
import Logging from '~app/core/logging';

const typeMap = {
  stockflow: 'stockflow-type-name',
  causal: 'causal-type-name',
  conceptual: 'conceptual-type-name',
  graph: 'conceptual-type-name',
};
const log = Logging.getLogger('app.features.saveLoad.index');

const ReferenceTableRow = ({ rowData }) => {
  const dispatch = useDispatch();
  const t = useT();
  const referenceRoot = './reference_models/models/';
  const thumbPath = './reference_models/thumbnails/';

  const loadModelFromPath = useCallback(
    e => {
      fetch(referenceRoot + rowData.model, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => response.json())
        .then(jsonData => {
          const data = JSON.stringify(jsonData);
          dispatch(CanvasActions.setDefaultEditMode(''));
          dispatch(SaveLoadActions.loadFromJSON({ data }));
        })
        .catch(error => {
          log.debug(error);
        });
    },
    [dispatch, rowData.model],
  );
  return (
    <tr className="Table__row Table__body-row">
      <td className="Table__col-thumb">
        <img
          className="thumbnail"
          src={
            rowData.thumb
              ? thumbPath + rowData.thumb
              : require('~app/resources/images/defaultThumb.svg')
          }
          alt=""
        />
      </td>
      <td className="Table__col-title">{rowData.name}</td>
      <td className="Table__col-type">{t(typeMap[rowData.type])}</td>
      <td className="Table__col-description Table__col-description-text">
        {rowData.description}
      </td>
      <td className="Table__col-download">
        <button
          className="Table__button"
          onClick={loadModelFromPath}
          aria-label={t('open')}
          tabIndex="0"
        >
          {t('open')}
        </button>
      </td>
    </tr>
  );
};

export default ReferenceTableRow;
